import React, { useState, useEffect } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import './Testimonials.css';

interface ActivityImage {
  id: number;
  image: string;
}

const Testimonials: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const activityImages: ActivityImage[] = [
    {
      id: 1,
      image: '/images/1.webp',
    },
    {
      id: 2,
      image: '/images/2.webp',
    },
    {
      id: 3,
      image: '/images/3.webp',
    },
    {
      id: 4,
      image: '/images/4.webp',
    },
    {
      id: 5,
      image: '/images/5.webp',
    },
    {
      id: 6,
      image: '/images/6.webp',
    },
    {
      id: 7,
      image: '/images/7.webp',
    },
    {
      id: 8,
      image: '/images/8.webp',
    },
    {
      id: 9,
      image: '/images/9.webp',
    },
    {
      id: 10,
      image: '/images/10.webp',
    },
    {
      id: 11,
      image: '/images/11.webp',
    },
    {
      id: 12,
      image: '/images/12.webp',
    },
    {
      id: 13,
      image: '/images/13.webp',
    },
    {
      id: 14,
      image: '/images/14.webp',
    },
    {
      id: 15,
      image: '/images/15.webp',
    },
    {
      id: 16,
      image: '/images/16.webp',
    },
    {
      id: 17,
      image: '/images/17.webp',
    },
    {
      id: 18,
      image: '/images/18.webp',
    },
    {
      id: 19,
      image: '/images/19.webp',
    },
  ];

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % activityImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, activityImages.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToPrevious = () => {
    const index = currentIndex === 0 ? activityImages.length - 1 : currentIndex - 1;
    goToSlide(index);
  };

  const goToNext = () => {
    const index = (currentIndex + 1) % activityImages.length;
    goToSlide(index);
  };

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials-container" ref={ref}>
        <div className={`section-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">活动图库</h2>
          <p className="section-subtitle">
            精彩活动瞬间，见证我们的专业服务与温暖陪伴
          </p>
        </div>

        <div className={`activity-carousel ${isVisible ? 'visible' : ''}`}>
          <button
            className="carousel-button prev"
            onClick={goToPrevious}
            aria-label="Previous image"
          >
            ‹
          </button>

          <div className="carousel-track">
            {activityImages.map((activity, index) => (
              <div
                key={activity.id}
                className={`activity-slide ${
                  index === currentIndex ? 'active' : ''
                } ${index < currentIndex ? 'prev' : ''} ${
                  index > currentIndex ? 'next' : ''
                }`}
              >
                <div className="activity-image-wrapper">
                  <img
                    src={activity.image}
                    className="activity-image"
                  />
                </div>
              </div>
            ))}
          </div>

          <button
            className="carousel-button next"
            onClick={goToNext}
            aria-label="Next image"
          >
            ›
          </button>

          <div className="carousel-dots">
            {activityImages.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to image ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
